import React from "react";
import Chart from "react-google-charts";
import Loader from "../../Utils/Loader"
import useIsMobile from "../../../hooks/useIsMobile";

function MainTransactionsChart({data}) {
    const isMobile = useIsMobile();

    let colors = {};

    if (Boolean(data)) {

        const cols = Object.assign({}, data.cols);
        delete cols[0];

        Object.values(cols).map((el, index) => {

            switch (el.label) {
                case "Payout Pending":
                    colors[index] = {color: '#3b1a1a'};
                    break;
                case "Purchase Pending":
                    colors[index] = {color: '#498183'};
                    break;
                case "Payout Decline":
                    colors[index] = {color: '#DC3912'};
                    break;
                case "Refund Decline":
                    colors[index] = {color: '#782ad4'};
                    break;
                case "Reversal Decline":
                    colors[index] = {color: '#a9218e'};
                    break;
                case "Recurrent Decline":
                    colors[index] = {color: '#c35624'};
                    break;
                case "Purchase Decline":
                    colors[index] = {color: '#a1c324'};
                    break;
                case "Purchase":
                    colors[index] = {color: '#3366CC'};
                    break;
                case "Recurrent":
                    colors[index] = {color: '#a0e720'};
                    break;
                case "Reversal":
                    colors[index] = {color: '#1eba8e'};
                    break;
                case "Refund":
                    colors[index] = {color: '#518cea'};
                    break;
                case "Payout":
                    colors[index] = {color: '#109618'};
                    break;
                case "Chargeback":
                    colors[index] = {color: '#644f0b'};
                    break;
                case "Created":
                    colors[index] = {color: '#3a828c'};
                    break;
                case "Pending 3DS Authentication":
                    colors[index] = {color: '#581b1b'};
                    break;
                case "Refund Pending":
                    colors[index] = {color: '#82afef'};
                    break;
                case "Reversal Pending":
                    colors[index] = {color: '#02ecab'};
                    break;
                case "Recurrent Pending":
                    colors[index] = {color: '#638b1a'};
                    break;
                case "Payout Created":
                    colors[index] = {color: '#5de6f8'};
                    break;
                case "Refund Created":
                    colors[index] = {color: '#0468f5'};
                    break;
                case "Reversal Created":
                    colors[index] = {color: '#058b66'};
                    break;
                case "Recurrent Created":
                    colors[index] = {color: '#3b5702'};
                    break;
                case "Purchase Created":
                    colors[index] = {color: '#5977b3'};
                    break;
                case "Оборот":
                    colors[index] = {color: '#990099', type: 'line', targetAxisIndex: 1};
                    break;
                default:
                    break;
            }

            return true;

        })

    }

    return (
        <Chart
            width={'100%'}
            height={isMobile ? '360px' : '300px'}
            chartType="ComboChart"
            loader={<Loader/>}
            data={data}
            options={{
                legend: isMobile
                    ? {position: 'bottom', textStyle: {fontSize: 11}, maxLines: 4}
                    : {textStyle: {fontSize: 11}},
                chartArea: {
                    width: isMobile ? '84%' : '75%',
                    height: isMobile ? '50%' : '62%',
                    top: isMobile ? 24 : undefined,
                },
                vAxis: {
                    title: 'Количество операций',
                    titleTextStyle: {italic: false}
                },
                hAxis: {
                    direction: 1,
                    slantedText: true,
                    slantedTextAngle: 90,
                    titleTextStyle: {italic: false},
                    textStyle: {
                        fontSize: 12
                    }
                },
                vAxes: {1: {title: 'Оборот', textStyle: {color: 'red'}}},
                seriesType: 'bars',
                series: colors,
                width: '100%',
                height: isMobile ? 360 : 300,
            }}
        />
    )

}

export default MainTransactionsChart;



// WEBPACK FOOTER //
// ./src/Components/Charts/MainTransactionsChart/index.js